import React from "react";
import {inject, observer} from "mobx-react";
import {CalculateStore} from "../../../stores/calculateStore";
import {ValidatedValue} from "../../../helpers/validator";
import {CalculationService} from "../../../services/services/calculationService";
import {PeselUtility} from "../../../helpers/peselUtility";
import TextInput from "../textInput/textInput";

interface PeselProps {
    calculateStore?: CalculateStore;
    pesel: ValidatedValue<string>;
    disabled?: boolean;
    recalculateOnChange?: boolean;
    calculationService?: CalculationService;
    refreshRisks?: boolean;
}

const PESEL_LENGTH: number = 11;

export function Pesel(props: PeselProps) {
    const calculateStore = props.calculateStore!;
    const calculationService = props.calculationService!;

    return (
        <div className="pesel">
            <div className="question-answer-container">
                <div className="question">PESEL</div>
                <div className="pesel-container">
                    <TextInput
                        disabled={props.disabled}
                        validatedValue={props.pesel}
                        onChange={(value) => onPeselInputChange(value)}
                        onlyNumberValue={true}
                        topLabel="PESEL"
                        maxLength={PESEL_LENGTH}
                    />
                </div>
            </div>
        </div>
    );

    function onPeselInputChange(value: string) {
        props.pesel.setValue(value);
        if (props.recalculateOnChange) {
            calculateStore.setRequireRecalculate(true);
            calculateStore.setRequireRecalculatePackages();
        }
        if (shouldRefreshRisks()) {
            calculationService.setRisksNetworkForAllPackages();
        }
    }

    function shouldRefreshRisks() {
        return props.refreshRisks && props.pesel.value.length === PeselUtility.PESEL_LENGTH;
    }
}

export default inject("calculateStore", "calculationService")(observer(Pesel));
